import { render, staticRenderFns } from "./CancelSubmitForm20.vue?vue&type=template&id=50105122&scoped=true"
import script from "./CancelSubmitForm20.vue?vue&type=script&lang=ts"
export * from "./CancelSubmitForm20.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50105122",
  null
  
)

export default component.exports